import React from "react";
import { Avatar, Card, CardContent, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(2),
    height: "100%",
  },
  avatar: (props) => ({
    fontSize: "28px",
    color: props.color || theme.palette.primary.main,
    // Fundo com 12% de opacidade da cor — funciona em dark e light mode
    backgroundColor: props.color
      ? `${props.color}1f`
      : theme.palette.type === "dark"
      ? "#2f3646"
      : "#f0f0f0",
    width: 52,
    height: 52,
    flexShrink: 0,
  }),
  content: {
    padding: 0,
    "&:last-child": { paddingBottom: 0 },
    minWidth: 0,
  },
  title: {
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: "1.4rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export default function CardCounter({ icon, title, value, loading, color }) {
  const classes = useStyles({ color });

  if (loading) return <Skeleton variant="rect" height={80} style={{ borderRadius: 8 }} />;

  return (
    <Card>
      <div className={classes.card}>
        <Avatar className={classes.avatar}>{icon}</Avatar>
        <CardContent className={classes.content}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.value}>
            {value ?? "—"}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
}
